export const ME = 'ME';
export const ORGANISATION = 'ORGANISATION';
export const OWNED_BY_FILTER_KEY = 'ownedByFilter';

// Common (Position and Jobs)
export const ACTIVE = 'ACTIVE';

// Job statuses
export const AWAITING_SELECTION = 'AWAITING_SELECTION';
export const CLOSED = 'CLOSED';
export const EXPIRED = 'EXPIRED';
export const EXPIRED_AND_NOT_DISMISSED = 'EXPIRED_AND_NOT_DISMISSED'; // Front-end specific status
export const OPEN = 'OPEN';
export const PENDING_CREDIT_APPROVAL = 'PENDING_CREDIT_APPROVAL';
export const UPCOMING = 'UPCOMING';

// Position statuses
export const APPROVED = 'APPROVED';
export const CANCELLED = 'CANCELLED';
export const DISPUTED = 'DISPUTED';
export const REQUESTED = 'REQUESTED';
export const TIMESHEET_AWAITING_APPROVAL = 'TIMESHEET_AWAITING_APPROVAL';

// Front end statuses for varius pages
export const CURRENT_JOBS_STATUSES = [OPEN, ACTIVE, PENDING_CREDIT_APPROVAL, UPCOMING, AWAITING_SELECTION];
export const PAST_JOBS_STATUSES = [CLOSED, EXPIRED];

// Notification categories
export const INSIGHT = 'INSIGHT';
export const FEED = 'FEED';

// Notification types
export const WEPLOYEE_EXTENSION_LIMIT = 'WEPLOYEE_EXTENSION_LIMIT';
export const WEPLOYEE_ARRIVING_SOON = 'WEPLOYEE_ARRIVING_SOON';
export const WEPLOYEE_FINISHED = 'WEPLOYEE_FINISHED';
export const WEPLOYEE_FINISHING_SOON = 'WEPLOYEE_FINISHING_SOON';
export const WEPLOYEE_MONTH_ANNIVERSARY = 'WEPLOYEE_MONTH_ANNIVERSARY';
export const WEPLOYEE_VISA_EXPIRING_SOON = 'WEPLOYEE_VISA_EXPIRING_SOON';
export const PREVIOUS_WEPLOYEE_AVAILABLE = 'PREVIOUS_WEPLOYEE_AVAILABLE';
